const LOGO_URL = "https://customer-assets.emergentagent.com/job_be07b2ae-bf5d-4602-962b-86b38f1ddae1/artifacts/zs78gc6h_Logo%2030%20anni%20CR%204.png";
const COMPANY_NAME = "CR Impianti Elettrici";
const COMPANY_SHORT = "CR";

export { LOGO_URL, COMPANY_NAME, COMPANY_SHORT };

// Dynamic brand support (for future SaaS use)
let _tenant = {};
export function setTenantBrand(tenant) { _tenant = tenant || {}; }
export function getLogo() { return _tenant.logo_url || LOGO_URL; }
export function getCompanyName() { return _tenant.company_name || COMPANY_NAME; }
export function getShortName() { return COMPANY_SHORT; }
export function getPrimaryColor() { return _tenant.primary_color || "#1e293b"; }
